import { render } from "./SalesByLocation.vue?vue&type=template&id=3cad17f4"
import script from "./SalesByLocation.vue?vue&type=script&lang=js"
export * from "./SalesByLocation.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__